/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UrlExclusionListModalQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type UrlExclusionListModalQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly suggestedUrlExclusionListRules: ReadonlyArray<string>, readonly urlExclusionList: { readonly __typename?: 'WebsiteUrlExclusionList', readonly rules: ReadonlyArray<string> } } | null };


export const UrlExclusionListModalDocument = gql`
    query UrlExclusionListModal($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    suggestedUrlExclusionListRules
    urlExclusionList {
      rules
    }
  }
}
    `;

/**
 * __useUrlExclusionListModalQuery__
 *
 * To run a query within a React component, call `useUrlExclusionListModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlExclusionListModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlExclusionListModalQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useUrlExclusionListModalQuery(baseOptions: Apollo.QueryHookOptions<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables> & ({ variables: UrlExclusionListModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>(UrlExclusionListModalDocument, options);
      }
export function useUrlExclusionListModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>(UrlExclusionListModalDocument, options);
        }
export function useUrlExclusionListModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>(UrlExclusionListModalDocument, options);
        }
export type UrlExclusionListModalQueryHookResult = ReturnType<typeof useUrlExclusionListModalQuery>;
export type UrlExclusionListModalLazyQueryHookResult = ReturnType<typeof useUrlExclusionListModalLazyQuery>;
export type UrlExclusionListModalSuspenseQueryHookResult = ReturnType<typeof useUrlExclusionListModalSuspenseQuery>;
export type UrlExclusionListModalQueryResult = Apollo.QueryResult<UrlExclusionListModalQuery, UrlExclusionListModalQueryVariables>;